import { getPhysicalClassLists } from '@/actions/physical-class';
import { Alert, Avatar, Button, Col, Row, Spin, Tag } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { ArrowRightOutlined } from '@ant-design/icons';
import { IerrorData } from '.';

type Props = {
  categoryData: (data: {}) => void;
  errorData: String;
  setErrorData: (data: IerrorData) => void;
  setClassId: (data: number) => void;
};

const SelectCategory: FC<Props> = ({
  categoryData,
  errorData,
  setErrorData,
  setClassId,
}) => {
  const [selectData, setSelectData] = useState<any>({});

  const dispatch = useDispatch();

  const lists = useSelector(
    (state: RootStateOrAny) => state.physicalClass.physicalClassList
  );

  const { data, error, loading } = lists;
  useEffect(() => {
    dispatch(getPhysicalClassLists());
  }, []);
  return (
    <div className="my-3">
      {errorData && (
        <Alert type="error" showIcon message={errorData} className="mb-3" />
      )}
      <p className="font-weight-bold mb-4" style={{ fontSize: '20px' }}>
        Select Physical Class
      </p>
      {!loading ? (
        <Row gutter={[20, 20]}>
          {data && data?.data?.length > 0 ? (
            data?.data?.map((each, i) => (
              <Col
                key={i}
                lg={{ span: 12 }}
                md={{ span: 24 }}
                sm={{ span: 24 }}
                xs={{ span: 24 }}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setSelectData(each);
                  setClassId(each?.id);
                  setErrorData({ courseError: '', dateTimeError: '' });
                }}
              >
                <div
                  className="rounded-lg shadow-sm px-2 py-3 h-100 hover-zoom"
                  style={{
                    border: '1px solid #dee2e6',
                    background: selectData?.id == each?.id ? '#e6f7ff' : '',
                  }}
                >
                  <Row className="d-flex align-items-center justify-content-center gap-2">
                    <Col
                      lg={{ span: 4 }}
                      md={{ span: 4 }}
                      sm={{ span: 4 }}
                      xs={{ span: 24 }}
                    >
                      <div className="d-flex justify-content-center w-100">
                        <Avatar
                          size={50}
                          style={{
                            background: '#283360',
                          }}
                        >
                          {each?.name?.charAt(0)?.toUpperCase()}
                        </Avatar>
                      </div>
                    </Col>
                    <Col
                      lg={{ span: 18 }}
                      md={{ span: 18 }}
                      sm={{ span: 18 }}
                      xs={{ span: 18 }}
                    >
                      <div>
                        {each?.name && (
                          <p
                            className="m-0 font-weight-bold mb-2"
                            style={{ fontSize: '16px' }}
                          >
                            {' '}
                            {each?.name}
                          </p>
                        )}
                        <div className="d-flex flex-wrap justify-content-between gap-2 w-100">
                          {each?.course_duration && (
                            <div>
                              <p className="m-0" style={{ fontSize: '14px' }}>
                                Duration:{' '}
                                <span
                                  className="font-weight-bold"
                                  style={{ fontSize: '14px' }}
                                >
                                  {each?.course_duration} days
                                </span>
                              </p>
                            </div>
                          )}
                          {each?.price && (
                            <div style={{ fontSize: '14px' }}>
                              <p className="m-0" style={{ fontSize: '14px' }}>
                                Price:&nbsp;&nbsp;
                                <Tag
                                  color="#283360"
                                  className="rounded-sm"
                                  style={{ fontSize: '12px' }}
                                >
                                  NRs. {each?.price}
                                </Tag>
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            ))
          ) : (
            <div className="m-auto">
              <h6>Class not Available.</h6>
            </div>
          )}
          <div className="my-2 mr-3 d-flex w-100 justify-content-end">
            <Button
              type="primary"
              className="float-right"
              onClick={() => {
                categoryData(selectData);
              }}
            >
              <div className="d-flex gap-2 align-items-center">
                Next <ArrowRightOutlined rev="" />
              </div>
            </Button>
          </div>
        </Row>
      ) : (
        <div className="d-flex align-items-center justify-content-center">
          <Spin />
        </div>
      )}
    </div>
  );
};

export default SelectCategory;
